"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatting = exports.complex = exports.basic = void 0;
exports.basic = [
    ["font", "fontSize"],
    ["fontColor"],
    ["horizontalRule"],
    ["link", "image"],
];
exports.complex = [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["removeFormat"],
    "/",
    ["fontColor", "hiliteColor"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list", "table"],
    ["link", "image", "video"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
    ["save", "template"],
];
exports.formatting = [
    ["undo", "redo"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["removeFormat"],
    ["outdent", "indent"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
];
